import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

import type { MarkdownToJSX as MarkdownNamespace } from "markdown-to-jsx";

import { useShouldExcludeBanner } from "@/common/hooks/pages.hooks";
import { analyticsService } from "@/common/services/analytics/analytics.service";

/*
 * ponytail: lazy so markdown-to-jsx (~102 KB) stays out of the shared _app
 * chunk — the Header is in MainLayout, so a static import taxed every page.
 * The banner renders only when marketing fills header-banner-text-1 in
 * Lokalise (empty in all locales today), so the chunk is usually never
 * fetched at all; when it is, ssr stays on so the banner still SSRs.
 */
const MarkdownToJSX = dynamic(() => import("markdown-to-jsx"));

const OPTIONS: MarkdownNamespace.Options = {
  overrides: {
    a: {
      props: {
        onClick: () => {
          analyticsService.trackAnnouncementBar();
        },
      },
    },
  },
};

export const HeaderEventsBanner = () => {
  const { t } = useTranslation();

  const translation = t("header:header-banner-text-1");
  const shouldExclude = useShouldExcludeBanner();

  if (shouldExclude) {
    return null;
  }

  // If the key doesn't exist in lokalise translations, the translation function will return the key itself, thus the second check.
  // We can influence the rendering of the banner component through lokalise. The banner will render only if the key has the translation.
  if (!translation || translation === "header-banner-text-1") {
    return null;
  }

  return (
    <div className="flex items-center justify-center bg-brand-500 px-12 py-2.5 font-title text-sm text-white">
      <span className="text-center">
        <MarkdownToJSX options={OPTIONS}>
          {t("header:header-banner-text-1")}
        </MarkdownToJSX>
      </span>
    </div>
  );
};
